<template>
  <i
    v-tooltip.top="tooltip"
    :class="[
      'ml-2',
      loading ? 'pi pi-spin pi-spinner text-bluegray-400' : 'pi pi-download',
      !loading &&
        (disabled ? 'text-bluegray-300' : 'cursor-pointer text-bluegray-400'),
    ]"
    style="font-size: 0.75rem"
    @click="!disabled && !loading && $emit('click')"
  />
</template>

<script>
export default {
  name: "ExportButton",
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  emits: ["click"],
  computed: {
    tooltip() {
      if (this.loading) return "Preparing download…";
      if (this.disabled) return "Nothing to export yet";
      return "Download CSV";
    },
  },
};
</script>
